
/* eslint-disable @typescript-eslint/no-explicit-any */
import BindCellphone from "./steps/bind-cellphone/index.vue";
import SupplierAttr from "./steps/supplier-attr/index.vue";
import BusinessLicense from "./steps/business-license/index.vue";
import SupplierInfo from "./steps/supplier-info/index.vue";
import SignProtocols from "./steps/sign-protocols/index.vue";
import Success from "./steps/success/index.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { StepForm } from "./common/StepForm";
import { mergeData } from "@/utils";
import { FormModel } from "@/service/common/entity/FormModel";
import { supplierSettled } from "@/service/supplier-meta/api";
import { SupplierInfoSubmitBO } from "@/service/supplier-meta/entity/SupplierInfoSubmitBO";
import { getCustomSupplierType } from "@/service/supplier-meta/common/supplier-info-service";
import {
  isFieldVisible,
  getFieldCtrlFn,
} from "@/service/supplier-meta/common/supplier-field-ctrl";
import cloneDeep from "lodash/cloneDeep";
@Component({
  components: {
    BindCellphone,
    SupplierAttr,
    BusinessLicense,
    SupplierInfo,
    SignProtocols,
    Success,
  },
  mixins: [],
})
export default class JoinUs extends Vue {
  //steps = ["bindCellphone", "supplier-attr", "business-license"];
  formData = {
    sourceTypeCode: null as number | null,
  };
  data: SupplierInfoSubmitBO | null = null;
  steps = [
    {
      label: "绑定手机号",
      value: "bindCellphone",
    },
    {
      label: "选择供应商属性",
      value: "supplierAttr",
    },
    {
      label: "上传营业执照",
      value: "businessLicense",
    },
    {
      label: "填写入驻信息",
      value: "baseInfo",
    },
    {
      label: "签订协议",
      value: "signProtocols",
    },
    {
      label: "提交成功",
      value: "success",
    },
  ];
  hiddenSteps = ["bindCellphone", "supplierAttr"];
  curStep = "bindCellphone";
  /** 渲染过的步骤。
   * 点击上一步、下一步时，渲染过的隐藏/显示
   */
  renderedSteps: string[] = ["bindCellphone"];
  isClothingCategory = false;
  validating = false;
  submitting = false;
  get activeStepIndex() {
    const curStepIndex = this.steps
      .filter((step) => !this.hiddenSteps.includes(step.value))
      .findIndex((ele) => ele.value === this.curStep);
    return curStepIndex;
  }
  get prevStepBtnVisible() {
    const curStepIndex = this.getCurrentStepIndex();
    return (
      curStepIndex > 0 &&
      curStepIndex < this.steps.length - 1 &&
      this.curStep !== "bindCellphone"
    );
  }
  get nextStepBtnVisible() {
    const curStepIndex = this.getCurrentStepIndex();
    return (
      curStepIndex < this.steps.length - 2 && this.curStep !== "bindCellphone"
    );
  }
  get submitBtnVisible() {
    const curStepIndex = this.getCurrentStepIndex();
    return curStepIndex === this.steps.length - 2;
  }
  get cancelStepBtnVisible() {
    const curStepIndex = this.getCurrentStepIndex();
    return (
      curStepIndex < this.steps.length - 1 && this.curStep !== "bindCellphone"
    );
  }
  @Watch("$route.query.step")
  handleQueryStepChange() {
    this.initStep();
  }
  created() {
    this.initStep();
  }
  initStep() {
    const queryStep = (this.$route.query.step as string) || "bindCellphone";
    if (queryStep && this.steps.some((step) => step.value === queryStep)) {
      this.curStep = queryStep;
      const currentStepIndex = this.getCurrentStepIndex();
      for (let i = 0; i <= currentStepIndex; i++) {
        this.markAsRendered(this.steps[i].value);
      }
    }
  }
  get ifStep() {
    return (stepName: string) => {
      return this.renderedSteps.indexOf(stepName) >= 0;
    };
  }
  get showStep() {
    return (stepName: string) => {
      return this.curStep === stepName;
    };
  }
  get cacheable() {
    return (stepName: string) => {
      return this.curStep === stepName;
    };
  }
  /**
   * 标记为已渲染
   */
  markAsRendered(stepName: string) {
    if (
      this.steps.some((step) => step.value === stepName) &&
      this.renderedSteps.indexOf(stepName) < 0
    ) {
      this.renderedSteps.push(stepName);
    }
  }
  getCurrentStepIndex() {
    const curStepIndex = this.steps.findIndex(
      (ele) => ele.value === this.curStep
    );
    return curStepIndex;
  }
  prevStep() {
    const curStepIndex = this.getCurrentStepIndex();
    if (curStepIndex > 0) {
      const nextStep = this.steps[curStepIndex - 1].value;
      this.curStep = nextStep;
      this.$router.replace({ name: "joinUs", query: { step: this.curStep } });
    }
  }
  /**
   * 下一步
   * @param validate 是否校验
   */
  async nextStep(validate = true) {
    this.validating = true;
    const curStepIndex = this.getCurrentStepIndex();
    const curSteppage = this.$refs[this.curStep] as StepForm; // 当前步骤页引用。约定：组件引用与步骤名称相同
    const valid = validate
      ? await curSteppage.validate().catch(() => false)
      : true;
    this.validating = false;
    if (!valid) {
      return;
    }
    const curStepData = curSteppage.getFormData();
    // this.formData = Object.assign(curStepData);
    mergeData(curStepData, this.formData); // 将当前步骤数据合并
    if (curStepIndex < this.steps.length - 1) {
      const nextStep = this.steps[curStepIndex + 1];
      this.curStep = nextStep.value;
      this.markAsRendered(this.curStep);
      this.$router.push({ name: "joinUs", query: { step: this.curStep } });
    }
  }
  handleCacheRecovered(stepName: string) {
    const steppage = this.$refs[stepName] as StepForm;
    const formData = steppage.getFormData();
    mergeData(formData, this.formData);
  }
  handleSubFormChange(data: FormModel) {
    mergeData(data, this.formData);
  }
  getCustomSupplierType() {
    const formData = this.formData as any as SupplierInfoSubmitBO;
    const customSupplierType = getCustomSupplierType(
      this.isClothingCategory,
      formData.factoryInfo?.supplyClassification,
      formData.enterpriseInfo?.supplyType
    );
    return customSupplierType;
  }
  handleResubmit(data: SupplierInfoSubmitBO) {
    if (this.curStep === "bindCellphone") {
      this.nextStep(false);
    }
    this.data = data;
  }
  resetUnvisibleField(data: FormModel, excludes?: string[]): void {
    const fieldVisible = getFieldCtrlFn(
      isFieldVisible,
      this.formData.sourceTypeCode || -1,
      this.isClothingCategory,
      this.formData as any as SupplierInfoSubmitBO
    );
    const resetFn = (
      path: string,
      obj: { [x: string]: any },
      field: string
    ) => {
      if (
        !fieldVisible(path) &&
        !(Array.isArray(excludes) && excludes.includes(path))
      ) {
        if (Array.isArray(obj[field])) {
          obj[field] = [];
        } else if (obj[field] && typeof obj[field] === "object") {
          Object.keys(obj[field]).forEach((key) => {
            resetFn(path ? `${path}.${key}` : key, obj[field], key);
          });
        } else if (typeof obj[field] === "string") {
          obj[field] = "";
        } else if (typeof obj[field] === "boolean") {
          obj[field] = null;
        } else {
          obj[field] = null;
        }
      }
    };
    Object.keys(data).forEach((key) => {
      resetFn(key, data, key);
    });
  }
  trimData(obj: any) {
    if (Array.isArray(obj)) {
      obj.forEach((item, index) => {
        obj[index] = this.trimData(item);
      });
    } else if (obj && typeof obj === "object") {
      Object.keys(obj).forEach((key: string) => {
        obj[key] = this.trimData(obj[key]);
      });
    } else if (typeof obj === "string") {
      obj = obj.trim();
    }
    return obj;
  }
  async submit() {
    const curSteppage = this.$refs[this.curStep] as StepForm;
    const valid = await curSteppage.validate();
    if (!valid) {
      return;
    }
    this.resetUnvisibleField(this.formData, [
      "enterpriseInfo.categoryPathName",
      "enterpriseInfo.paymentTypeList",
      "bindingPhone",
      "sourceTypeCode",
      "checkGroup",
    ]);
    let data = cloneDeep(this.formData as unknown as SupplierInfoSubmitBO);
    const customSupplierType = this.getCustomSupplierType() || 0;
    data.checkGourp = customSupplierType;
    data = this.trimData(data);
    console.log(data);
    this.submitting = true;
    delete data.capacity; // 删除产能字段，避免缓存带来的影响
    const res = await supplierSettled(data);
    if (res.isSuccess) {
      this.nextStep(false);
    }
    this.submitting = false;
  }
  cancel() {
    window.open("about:blank", "_self")?.close();
  }
  handleCancel() {
    this.cancel();
  }
}
